import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { InAppNotification, NotificationClientService } from '../client/notification-client/notification-client.service';
import { PoliticsModeService } from './politics-mode.service';

@Injectable({ providedIn: 'root' })
export class InAppNotificationService {
  private _notifications$ = new BehaviorSubject<InAppNotification[]>([]);

  readonly notifications$ = this._notifications$.asObservable();

  get count(): number {
    return this._notifications$.getValue().length;
  }

  get count$() {
    return new BehaviorSubject<number>(this.count).asObservable();
  }

  constructor(
    private notificationClient: NotificationClientService,
    private politicsModeService: PoliticsModeService,
  ) {}

  /**
   * Busca notificações in-app pendentes do backend e publica no stream.
   * Usado no bootstrap (com token antigo/inválido) e deve ser chamado
   * novamente após o login, quando o token válido estiver disponível.
   */
  loadPending(): void {
    this.notificationClient.getPendingInApp(this.politicsModeService.isPolitics ? 'POLITICS' : 'COMMERCIAL').subscribe({
      next: (notifications) => {
        if (!notifications || notifications.length === 0) { return; }
        this.push(notifications);
      },
      error: () => {},
    });
  }

  push(notifications: InAppNotification[]): void {
    this._notifications$.next(notifications);
  }

  dismiss(id: string): void {
    this.notificationClient.markInAppRead(id).subscribe();
    const updated = this._notifications$.getValue().filter(n => n.id !== id);
    this._notifications$.next(updated);
  }

  labelFor(type: string): string {
    switch (type) {
      case 'VALIDATION_OK': return 'Sua missão foi validada com sucesso!';
      case 'VALIDATION_FAILED': return 'Sua missão não passou na verificação.';
      // Missão fixa de cadastro — os tipos são os códigos de template do back.
      case 'MISSION_INVITE': return 'Sua primeira missão chegou: complete o seu cadastro!';
      case 'ONBOARDING_ACCEPT_1MIN': return 'Falta 1 minuto para você aceitar a missão de cadastro.';
      case 'ONBOARDING_MUST_DO': return 'A missão de cadastro é obrigatória. Aceite e você terá 24h para concluir.';
      case 'ONBOARDING_DEADLINE_25': return 'Sua missão de cadastro está esperando. Continue de onde parou!';
      case 'ONBOARDING_DEADLINE_75': return 'Falta pouco tempo para concluir a missão de cadastro.';
      case 'ONBOARDING_DEADLINE_5MIN': return 'Últimos 5 minutos! Se não concluir, você deixa de ganhar 1 ponto.';
      case 'ONBOARDING_PENALTY': return 'O prazo passou e a missão perdeu 1 ponto. Você tem mais 24h.';
      default: return 'Você tem uma nova notificação.';
    }
  }

  iconFor(type: string): string {
    switch (type) {
      case 'VALIDATION_OK': return 'checkmark-circle-outline';
      case 'VALIDATION_FAILED': return 'close-circle-outline';
      case 'MISSION_INVITE': return 'flag-outline';
      case 'ONBOARDING_ACCEPT_1MIN':
      case 'ONBOARDING_DEADLINE_25':
      case 'ONBOARDING_DEADLINE_75':
      case 'ONBOARDING_DEADLINE_5MIN': return 'time-outline';
      case 'ONBOARDING_MUST_DO': return 'alert-circle-outline';
      case 'ONBOARDING_PENALTY': return 'trending-down-outline';
      default: return 'notifications-outline';
    }
  }
}
